import { render, staticRenderFns } from "./RegisterComponent.vue?vue&type=template&id=5029900e&scoped=true&"
import script from "./RegisterComponent.vue?vue&type=script&lang=ts&"
export * from "./RegisterComponent.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterComponent.vue?vue&type=style&index=0&id=5029900e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5029900e",
  null
  
)

export default component.exports